import Navbar from "./components/navbar/Navbar";
import Hero from "./components/hero/Hero";
import Services from "./components/services/Services";
import SizeMarker from "./components/sizemarker/SizeMarker";
import Prices from "./components/prices/Prices";
import KnowHow from "./components/knowhow/KnowHow";
import Contact from "./components/contact/Contact";
import EducationCollapse from "./components/educationCollapse/EducationCollapse";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <EducationCollapse />
      <Services />
      <Prices />
      <KnowHow />
      <Contact />
      {/* <SizeMarker /> */}
    </div>
  );
}

export default App;
